export default defineNuxtPlugin(() => {
  // const script = document.createElement('script');
  // script.src = '//cdn.cookie-script.com/s/a915df6382f9c3f5f82168e860f4bbd8.js';
  // script.type = 'text/javascript';
  // script.charset = 'UTF-8';
  // document.head.appendChild(script);
});
